import { createShallowStore, createStoreWithPersistAndSubscribe } from '@frontend/store';

type FaxSearchFilters = {
  tags: string[];
  faxNumbers: string[];
  startDate: string;
  endDate: string;
  direction: string;
  isRead: string;
  isDelivered: string;
};

interface FaxSearchFiltersStore {
  faxSearchFilters: FaxSearchFilters;
  setFaxSearchFilters: (val: FaxSearchFilters) => void;
  resetFaxSearchFilters: () => void;
}

export const useFaxSearchFiltersStore = createStoreWithPersistAndSubscribe<FaxSearchFiltersStore>(
  (set) => ({
    faxSearchFilters: {
      tags: [],
      faxNumbers: [],
      startDate: '',
      endDate: '',
      direction: '',
      isRead: '',
      isDelivered: '',
    },
    setFaxSearchFilters: (args: FaxSearchFilters) =>
      set(
        (state) => {
          state.faxSearchFilters = { ...state.faxSearchFilters, ...args };
        },
        false,
        'SET_FAX_SEARCH_FILTERS'
      ),
    resetFaxSearchFilters: () =>
      set(
        (state) => {
          state.faxSearchFilters = {
            tags: [],
            faxNumbers: [],
            startDate: '',
            endDate: '',
            direction: '',
            isRead: '',
            isDelivered: '',
          };
        },
        false,
        'RESET_FAX_SEARCH_FILTERS'
      ),
  }),
  { name: 'FaxSearchFiltersStorage', version: 2 },
  { name: 'FaxSearchFilters', trace: true }
);

export const useFaxSearchFiltersShallowStore = createShallowStore(useFaxSearchFiltersStore);
